import { PersonalizationOptions } from '@Components/Product/ProductTypes'
import { ProductVariant } from '@Generated/graphql'

export interface ProductPersonalization extends Omit<ProductVariant, '__typename'> {
  __typename: 'Product' | undefined
  masterVariant: PersonalizationOptions
  primaryAsset: {
    __typename: 'Asset' | undefined
    url: string
  }
}

export interface Personalization {
  id: string | number
  image: string
  isFree?: boolean
  legacyID?: { value: string }
  maxCharacters: number | undefined
  placement: Record<string, string>
  price: string
  type: string
}

export type PersonalisationModalTypes = 'deboss' | 'engrave' | 'gift-card'

const personalizationTranslationHeader = {
  engrave: 'products:PERSONALISED_ENGRAVING',
  deboss: 'products:PERSONALISED_DEBOSSING',
}

export const getPersonalizationTranslationHeader = (product: { masterVariant: PersonalizationOptions }) => {
  const { key } = product.masterVariant.type.value
  return personalizationTranslationHeader[key]
}
